export function toDate(date, format = "client") {
    if (!date) return null;
    if (date instanceof Date) return date;

    if (typeof date === "number") return new Date(date);

    const [dateString] = date.split(" ");
    if (!dateString) return null;

    if (format === "client") {
        const [day, month, year] = dateString.split(".");
        return new Date(year, parseInt(month, 10) - 1, parseInt(day, 10));
    }

    const [year, month, day] = dateString.split("-");
    return new Date(year, parseInt(month, 10) - 1, parseInt(day, 10));
}
